import { useQueryClient } from "@tanstack/react-query";
import { Loader2, Printer } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import handlePrint from "@/utils/handlePrint";
import FindOnePayslip from "@/v2/api/payslip/FindOne";
import ArEmployeePayslipPDF from "./ArEmployeePayslipPdf";

export default function PrintArEmployeePayslipPDF({
  payslipId,
  isInside = false,
}: {
  payslipId: string;
  isInside?: boolean;
}) {
  const queryClient = useQueryClient();
  const [isPrinting, setIsPrinting] = useState(false);

  const handlePrintProcess = async () => {
    try {
      setIsPrinting(true);

      const data = await queryClient.fetchQuery({
        queryKey: [payslipId, "payslip"],
        queryFn: () => FindOnePayslip(payslipId),
      });

      await handlePrint(<ArEmployeePayslipPDF data={data} />, {
        fileName: `Payslip-${data.month}-${data.year}-${data?.employee.full_name}`,
      });
    } catch (error) {
      console.error("Failed to fetch timesheet:", error);
    } finally {
      setIsPrinting(false);
    }
  };

  return (
    <div>
      <Button
        variant="outline"
        onClick={handlePrintProcess}
        disabled={isPrinting}
        size={"sm"}
      >
        {isPrinting ? (
          <Loader2 className="animate-spin" />
        ) : (
          <div className="flex items-center gap-2">
            <Printer />
            {isInside && <span>Print</span>}
          </div>
        )}
      </Button>
    </div>
  );
}
